import '../../app.base'

//
let exports = {};
// ====================================================================================
// 参考文档：https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe
var _blankPage = 'about:blank';
var PageVueDef = {
    name: 'page-view',
    props: {
        //=> src
        url: {
            type: String,
            default: _blankPage
        },
        //=> srcdoc
        doc: {
            type: String,
            default: null
        },
        //错误信息
        errMsg: {
            type: String,
            default: ''
        },
        width: {
            default: '100%'
        },
        height: {
            default: '100%'
        },
        border: {
            type: String,
            default: '0px'
        }
    },
    data: function () {
        return {};
    },
    template: '<iframe :style="{ width : width, height : height, border : border}" referrerpolicy="origin-when-cross-origin" sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-modals allow-downloads allow-top-navigation" seamless="seamless"></iframe>',
    watch: {
        url(newVal, oldVal) {
            this.$el.removeAttribute('srcdoc');
            //
            this.refresh();
        },
        doc(newVal, oldVal) {
            this.$el.removeAttribute('src');
            //
            this.refresh();
        },
        errMsg(newVal, oldVal) {
            this.$el.removeAttribute('srcdoc');
            this.$el.removeAttribute('src');
            //
            this.refresh();
        }
    },
    mounted() {
        this.refresh();
    },
    methods: {
        refresh() {
            if (this.errMsg && this.errMsg.length > 0) {
                this.$el.setAttribute('srcdoc', '<div style="width: 100%; height: 40px; text-align: center; margin-top: 100px;color:red;">{0}</div>'.format(this.errMsg));
            } else {
                if (this.doc && this.doc.length > 0) {
                    this.$el.setAttribute('srcdoc', this.doc);
                } else {
                    this.$el.setAttribute('src', this.url || _blankPage);
                }
            }
        }
    }
};

// 固定代理路由注册path
var $routePath = '/comn/outer/page/view'

// 返回单一组件路由path
export function getPageRoutePath() {
    return $routePath;
}

// 设置单一组件路由path
export function setPageRoutePath(routePath) {
    $routePath = routePath;
}

// 根据 query 获取并回调得到的最终页面url
var $urlProvider = null;

//urlProvider(query, callback(result))
export function setPageUrlProvider(urlProvider) {
    if (typeof urlProvider == 'function') {
        $urlProvider = urlProvider;
    }
}

//
export var OuterPageView = {
    components: {
        'page-view': PageVueDef
    },
    name: 'outer-page-view',
    template: '<div style="width: 100%;height: 100%; overflow-y: hidden;"><page-view :url="pageUrl" :doc="pageDoc" :err-msg="errMsg"></page-view></div>',
    props: {
        //直接指定url
        url: {
            type: String
        },
        doc: {
            type: String
        }
    },
    data: function () {
        return {
            pageUrl: null,
            pageDoc: null,
            errMsg: null
        }
    },
    watch: {
        '$route': function (newVal, oldVal) {
            this.refresh();
        },
        '$attrs.query': function (newVal, oldVal) {
            this.refresh();
        },
        url: function (newVal, oldVal) {
            this.refresh();
        },
        doc: function (newVal, oldVal) {
            this.refresh();
        }
    },
    mounted() {
        this.refresh();
    },
    methods: {
        refresh() {
            //优先使用路由和query
            if (this.$route || this.$attrs.query) {
                var routeQuery = this.$getRouteQuery();
                console.log(routeQuery);
                //
                if ($urlProvider) {
                    let self = this;
                    $urlProvider(routeQuery, function (result) {
                        if (result.success) {
                            self.pageUrl = result.data || '';
                        } else {
                            self.errMsg = '获取页面url失败：' + result.message;
                            console.error(self.errMsg);
                        }
                    });
                } else {
                    this.errMsg = '尚未设置 setPageUrlProvider(urlProvider)';
                    console.error(this.errMsg);
                }
            } else {
                this.pageUrl = this.url || null;
                this.pageDoc = this.doc || null;
            }
        }
    }
};

// ====================================================================================
exports.setPageRoutePath = setPageRoutePath;
exports.getPageRoutePath = getPageRoutePath;
exports.OuterPageView = OuterPageView;

exports.setPageUrlProvider = setPageUrlProvider;
// ===================
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/compo/ctrl/OuterPage.js
// module id = 229
// module chunks = 0